import { type TranslateObject, type TranslationAPI } from '@lumapps/translations';

export type WithLang = { lang?: string };

/**
 * Selects the best localized item from a list by delegating language
 * resolution/fallbacks to `translateObject` from @lumapps/translations.
 *
 * @returns The item chosen by `translate`, or `undefined` if none match.
 */
export const selectLocalized = <T extends WithLang>(
    items: T[],
    translateObject: TranslationAPI['translateObject'],
): T | undefined => {
    const dict = Object.fromEntries(items.map((i) => [i.lang ?? 'undefined', i])) as TranslateObject;

    return (translateObject(dict) as T) || undefined;
};
